import { gatewayPhone } from "../../../../gateways/gatewayPhone";
import { CallHistoryListResponse } from "../types";

interface FetchCallHistoryParams {
  sessionNumber?: string;
  pageParam?: number;
  limit?: number;
  status?: string;
  direction?: "inbound" | "outbound";
}

export const fetchCallHistory = async ({
  sessionNumber,
  pageParam,
  limit,
  status,
  direction,
}: FetchCallHistoryParams): Promise<CallHistoryListResponse> => {
  const token = sessionStorage.getItem("token");

  if (!token) {
    throw new Error("No auth token found");
  }

  const { data } = await gatewayPhone.get<CallHistoryListResponse>(
    "/twilio/call/history",
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      params: {
        phoneNumber: sessionNumber || undefined,
        limit,
        offset: pageParam,
        status: status ?? undefined,
        direction: direction ?? undefined,
      },
    }
  );

  return data;
};